import MorphDialog from './MorphDialog';

export default MorphDialog;
export * from './MorphDialog';
